import { msg } from '@gonfalon/messages/msg';

import styles from './SkeletonChart.module.css';

export function SkeletonChart() {
  return (
    <div className={styles.overlay} role="progressbar" aria-label={msg('dataviz.chart.loadingLabel')}>
      <div className={styles.container}></div>
    </div>
  );
}
